import type { Rule } from "antd/es/form";

const defaultLabel = "It";

export const regexPatterns = {
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[@#!$%^&+=])(?=.*[0-9]).*$/,
  mobileNumber: /^\d{3}-\d{3}-\d{4}$/,
  twoDecimal: /^\d*(\.\d{0,2})?$/,
  numeric: /^[0-9\b]+$/,
  // phone: /^\d{4} \d{3} \d{3}$/,
  mobilevalidation: /^[0-9]{10}$/,
  firstName: /^(?=.*[a-z])(?=.*[A-Z]).*$/,
  lastName: /^(?=.*[a-z])(?=.*[A-Z]).*$/,
  firstLetterUpperCase: /^(?=.*[a-z])(?=.*[A-Z]).*$/,
  numericNotAllow:/^[^\d]*$/  ,
  noSpecialChar:/^[a-zA-Z0-9]+$/
  // url: /^(http(s)?:\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/,
};

export const validations = {
  required: {
    text: (field = defaultLabel) => {
      return {
        required: true,
        message: `${field} is required.`,
      };
    },
    select: (field = defaultLabel) => {
      return { required: true, message: `Please select ${field}.` };
    },
  },
  min: {
    text: (min = 3, field = defaultLabel) => {
      return {
        min,
        message: `${field} should contain minimum ${min} characters.`,
      };
    },
    select: (field = defaultLabel, min: number) => {
      return {
        min,
        message: `Please select minimum ${min} ${field}.`,
      };
    },
    number: (min: number, field = defaultLabel) => {
      console.log(min,field)
      return {
        min,
        message: `${field} should contain minimum ${min} digits.`,
      };
    },
  },
  max: {
    text: (max = 20, field = defaultLabel) => {
      return {
        max,
        message: `${field} should contain maximum ${max} characters.`,
      };
    },
    select: (field = defaultLabel, max: number) => {
      return {
        max,
        message: `Please select maximum ${max} ${field}.`,
      };
    },
    number: (max: number, field = defaultLabel) => {
      return {
        max,
        message: `${field} should contain maximum ${max} digits.`,
      };
    },
  },
  pattern: {
    firstLetterUpperCase: {
      pattern: regexPatterns.firstLetterUpperCase,
      message: "The first character should be in uppercase",
    },
    firstName: {
      pattern: regexPatterns.firstName,
      message: "First letter must be capital",
    },
    lastName: {
      pattern: regexPatterns.lastName,
      message: "First letter must be capital",
    },
    phone: {
      pattern: regexPatterns.mobilevalidation,
      message: "Phone should contain only 10 numbers.",
    },
    mobileNumber: (message?: string) => {
      return {
        pattern: regexPatterns.mobileNumber,
        message: message || "Invalid Mobile number",
      };
    },
    password: (field = defaultLabel) => {
      return {
        pattern: regexPatterns.password,
        message: `${field} should contain at least an uppercase letter, a lowercase letter, a number, and a special character.`,
      };
    },
    numeric: {
      pattern: regexPatterns.numeric,
      message: "Please enter digits only.",
    },
    decimal: (number: number) => {
      return {
        pattern: regexPatterns.twoDecimal,
        message: `Please enter digits or decimal digits up to ${number} decimal places only.`,
      };
    },
    specialChar:(field = defaultLabel)=>{
      return{
      pattern: regexPatterns.noSpecialChar,
      message: `Special characters are not allowed in ${field}`};
    },
    numericValuesNotAllow:(field = defaultLabel)=>{
      return{
      pattern: regexPatterns.numericNotAllow,
      message: `Numeric Values are not allowed in ${field}`};
    },
    other: (field = defaultLabel) => {
      return {
        pattern: regexPatterns.firstName,
        message: `Please enter a valid ${field}.`,
      };
    },
  },
  email: (field = defaultLabel) => {
    return {
      type: "email",
      message: `${field} Is Invalid email.`,
    };
  },
  url: (
    field = defaultLabel,
    message = `Please enter a valid URL for ${field}.`
  ): Rule => {
    return {
      type: "url",
      message: message,
    };
  },
  validators: {
    validateNumber: (
      rule: any,
      value: number | undefined,
      minValue: number,
      maxValue: number
    ) => {
      if (value === undefined || isNaN(value)) {
        return Promise.reject("Please enter a valid number.");
      } else if (value < minValue) {
        return Promise.reject(
          `Value must be greater than or equal to ${minValue}.`
        );
      } else if (value > maxValue) {
        return Promise.reject(
          `Value must be less than or equal to ${maxValue}.`
        );
      }
      return Promise.resolve();
    },
  },
};
